function TermsPage() {
  return (
    <div className="py-12 bg-slate-50">
      <div className="container mx-auto px-4 max-w-3xl">
        <h1 className="text-4xl font-bold mb-8 glow-text">Terms of Service</h1>
        <div className="bg-white rounded-xl shadow-lg p-8">
          <p className="mb-4">Last Updated: May 21, 2025</p>
          
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">1. Introduction</h2>
            <p className="mb-4">
              Welcome to Family Dashboard. These Terms of Service ("Terms") govern your use of the Family Dashboard application ("Application") provided by Ryken Labs, LLC ("we," "our," or "us").
            </p>
            <p>
              By using the Application, you agree to these Terms. If you disagree with any part of the Terms, you may not use our Application.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">2. Application Use</h2>
            <p className="mb-4">
              Family Dashboard is an application designed to display family information including calendar events, photos, weather, and educational content.
            </p>
            <p className="mb-4">
              You may use our Application for personal, non-commercial purposes only. You agree not to modify, adapt, or hack the Application or modify another website to falsely imply that it is associated with Family Dashboard.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">3. Account Creation and Security</h2>
            <p className="mb-4">
              To use certain features of the Application, you must authorize access to your Google account through the OAuth authentication process.
            </p>
            <p className="mb-4">
              You are responsible for:
            </p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Maintaining the confidentiality of your Google account credentials</li>
              <li>All activities that occur under your account</li>
              <li>Notifying us immediately of any unauthorized use of your account</li>
            </ul>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">4. Intellectual Property</h2>
            <p className="mb-4">
              The Application, including its original content, features, and functionality, is owned by us and is protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
            </p>
            <p className="mb-4">
              Our trademarks and trade dress may not be used in connection with any product or service without our prior written consent.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">5. User Content</h2>
            <p className="mb-4">
              Our Application may display content from your Google Calendar and photos that you provide from your phone or a local folder. You retain all rights to such content, and you are responsible for ensuring that you have the right to use, share, and display this content.
            </p>
            <p className="mb-4">
              By using the Application, you grant us a license to access, display, and process this content solely for the purpose of providing you with the Application's services.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">6. Third-Party Services and Links</h2>
            <p className="mb-4">
              Our Application utilizes third-party services such as the Google Calendar API, the Open-Meteo API, and the Anthropic Claude API. Your use of these services is subject to their respective terms and conditions.
            </p>
            <p className="mb-4">
              We are not responsible for the content, privacy policies, or practices of any third-party services. You release us from any liability arising from your use of third-party services.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">7. Termination</h2>
            <p className="mb-4">
              We may terminate or suspend your access to our Application immediately, without prior notice or liability, for any reason whatsoever, including, without limitation, if you breach the Terms.
            </p>
            <p className="mb-4">
              You may terminate your use of the Application at any time by uninstalling the Application and revoking our access to your Google account.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">8. Limitation of Liability</h2>
            <p className="mb-4">
              In no event shall we be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the Application.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">9. Warranty Disclaimer</h2>
            <p className="mb-4">
              The Application is provided "as is" and "as available" without any warranties of any kind, either express or implied, including but not limited to the implied warranties of merchantability, fitness for a particular purpose, or non-infringement.
            </p>
            <p className="mb-4">
              We do not warrant that the Application will be uninterrupted or error-free, that defects will be corrected, or that the Application is free of viruses or other harmful components.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">10. Changes to Terms</h2>
            <p className="mb-4">
              We reserve the right to modify these Terms at any time. If we make changes, we will provide notice by posting the updated Terms on this page and updating the "Last Updated" date.
            </p>
            <p className="mb-4">
              Your continued use of the Application after any such changes constitutes your acceptance of the new Terms.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-bold mb-4">11. Governing Law</h2>
            <p className="mb-4">
              These Terms shall be governed and construed in accordance with the laws of Virginia, United States, without regard to its conflict of law provisions.
            </p>
          </section>
          
          <section>
            <h2 className="text-2xl font-bold mb-4">12. Contact Us</h2>
            <p className="mb-4">
              If you have any questions about these Terms, please contact us at:
            </p>
            <div className="bg-gray-100 p-4 rounded">
              <p>Email: info@rykenlabs.com</p>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default TermsPage;